import { RefObject, useState } from 'react';
import { useEventListener } from './use-event-listener';

export function useHover<TElement extends HTMLElement>(elementRef: RefObject<TElement | null>) {
    const [hover, setHover] = useState(false);

    useEventListener(elementRef, 'mouseenter', () => setHover(true));
    useEventListener(elementRef, 'mouseleave', () => setHover(false));

    return hover;
}
